export { default } from "./ResultsLabel";
